<template>
    <UModal :title="$t('Privacy policy')" size="xl">
        <template #body>
                    <div class="p-4 max-h-96 overflow-y-auto">
            <p>
                {{ $t('Here is the privacy policy...') }}
            </p>
            <!-- Add actual privacy policy content here -->
        </div>
        </template>
        <template #footer="{ close }">
            <UButton @click="close" color="primary">{{ $t('Close') }}</UButton>
        </template>
    </UModal>
</template>